// assets
import { IconUsers, IconBed } from '@tabler/icons';

// constant
const icons = {
    IconUsers,
    IconBed
};

// ==============================|| IPDSTAFF MENU ITEMS ||============================== //

const ipdStaffMenuItems = [
    {
        id: 'main-pages',
        type: 'group',
        children: [
            {
                id: 'patients',
                title: 'Patients',
                type: 'item',
                icon: icons.IconUsers,
                url: '/patients',
                breadcrumbs: false
            },
            {
                id: 'ipd',
                title: 'IPD',
                type: 'collapse',
                icon: icons.IconBed,
                breadcrumbs: false,
                children: [
                    {
                        id: 'ipd-overview',
                        title: 'IPD Overview',
                        type: 'item',
                        url: '/ipd-overview',
                        breadcrumbs: false
                    }
                ]
            }
        ]
    }
];

export default ipdStaffMenuItems;
